import { render, staticRenderFns } from "./Rtextarea.vue?vue&type=template&id=ea2b95f4&"
import script from "./Rtextarea.vue?vue&type=script&lang=js&"
export * from "./Rtextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports